export type Direction = 'ltr' | 'rtl';
